export default (hit, isInit) => {
  return `
  <button ${isInit ? 'js-scroll-animations-target style="opacity: 0"' : ''} class="display-mobile talent-card w-full" js-modal-control="{target: '#modal-talent', dynamic: true, type: 'talent'}" data-id="${hit.internalId}">
    <div class="talent-card__img-wrap">
      <picture>
        <source media="(max-width:420px)" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_356,h_418/${hit.picture.singleMedia.publicId}">
        <source media="(max-width:767px)" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_703,h_826/${hit.picture.singleMedia.publicId}">
        <source media="(max-width:1023px)" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_450,h_530/${hit.picture.singleMedia.publicId}">
        <img width="386" height="454" class="w-full" height="500" width="500" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_386,h_454/${hit.picture.singleMedia.publicId}" alt="${hit.title}" />
      </picture>

      <picture>
        <source media="(max-width:420px)" src="/assets/front/img/dummy-pic.png">
        <source media="(max-width:767px)" src="/assets/front/img/dummy-pic.png">
        <source media="(max-width:1023px)" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_450,h_530/${hit.hoverPicture.singleMedia.publicId}">
        <img width="386" height="454" class="w-full talent-card__hover" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_386,h_454/${hit.hoverPicture.singleMedia.publicId}" alt="" />
      </picture>    
    </div>

    <p class="talent-card__name mt-3 md:mt-4">${hit.title}</p>
    <p class="font-secondary-italic talent-card__job mt-1">${hit.function}</p>
  </button>
  `
}
